// Navbar.jsx
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="bg-blue-600 text-white px-6 py-4 flex justify-between items-center shadow-md">
      <Link to="/" className="font-bold text-2xl hover:text-gray-200 transition duration-200">
        🌐 SocialEcho
      </Link>
      <div className="flex gap-6 text-lg">
        <Link to="/login" className="hover:text-gray-300 transition duration-200">
          Login
        </Link>
        <Link to="/register" className="hover:text-gray-300 transition duration-200">
          Register
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
